import { Pipe, PipeTransform, ViewChild } from '@angular/core';
import { ParticipationComponent } from '../participation/participation.component';
import { Questions } from '../common-class/questions';

@Pipe({
  name: 'questionstring',
  pure: false
})
export class QuestionStringPipe implements PipeTransform {

  constructor(private participation: ParticipationComponent) { }

  transform(question: Questions, args?: any): any {
    if(question.group_no == 0){
      return this.participation.GetQuestionsString(question, question.page_no -1);
    } else if(question.group_no > 0 && !question.isMatrixQuestion){
      return this.participation.GetMultiQuestionsString(question, question.page_no -1);
    } else if(question.group_no > 0 && question.isMatrixQuestion){
      return this.participation.GetMatrixGridQuestionsString(question, question.page_no -1)
    }
    return ;
  }
}
